import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import Navbars from '../components/navbars/Navbars';
import AsideNavbar from '../components/navbars/AsideNavbar';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import StudentProfileTabs from '../components/student_profile/StudentProfileTabs';

const FETCH_USER_PROFILE = gql`
query($student_user_exam_id: Int!) {
    getStudentProfile(student_user_exam_id: $student_user_exam_id){
        name
        email
        mobile
        valid
        class_id
        branch_id
        college_name
        institution_id
        institute_name
        profile_pic
        exam_id
        mobile_verified
        target_year
        feedback
        estatus
        branch_name
        section_name
        videos
        user_exams
        {
            exam_type
            hall_ticket_no
        }
     }
}
`;

// Maps the raw getStudentProfile payload onto the shape the profile UI expects.
const mapStudent = (p) => {
    if (!p) return undefined;
    const examInfo = (p.user_exams && p.user_exams[0]) || {};
    const classLabel = p.class_id == 1 ? '11' : (p.class_id == 2 ? '12' : p.class_id);
    const gradeParts = [];
    if (p.class_id) gradeParts.push(`Grade Class ${classLabel}`);
    if (p.section_name) gradeParts.push(`Section ${p.section_name}`);

    return {
        ...p,
        name: p.name,
        status: p.estatus == 1 ? 'Enrolled - Active' : 'Inactive',
        grade: gradeParts.join(' - '),
        rollNo: examInfo.hall_ticket_no || '',
        dob: '', // not provided by getStudentProfile
        instituteName: p.institute_name,
    };
};

class StudentProfilePage extends Component {
    menuToggler = () => {
        const toggled = Cookies.get('toggle');
        if (toggled === 'wrapper') {
            Cookies.set('toggle', 'wrapper sidebar-enable');
            this.setState({ toggled: 'wrapper sidebar-enable' });
        } else {
            Cookies.set('toggle', 'wrapper');
            this.setState({ toggled: 'wrapper' });
        }
    };

    render() {
        if (Cookies.get('studenttoken') == undefined) {
            this.props.history.push('/student/login');
        }

        const profileQuery = this.props.getStudentProfile || {};
        const loading = profileQuery.loading;
        const error = profileQuery.error;

        if (error !== undefined) {
            alert('Server Error. ' + error.message);
            return null;
        }

        const student = mapStudent(profileQuery.getStudentProfile);

        return (
            <div className={Cookies.get('toggle')}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    {loading == true && <PreloaderTwo />}
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <Container fluid>
                            {!loading && <StudentProfileTabs student={student} />}
                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(compose(
    graphql(FETCH_USER_PROFILE, {
        options: () => ({
            variables: {
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            },
            fetchPolicy: 'cache-and-network',
        }),
        name: 'getStudentProfile',
    }),
)(StudentProfilePage));
